module.exports = __webpack_public_path__ + "img/banner.da4dc906.png";